import { DeepMutable } from '@/util/deep-mutable';

export default function deepClone<T>(o: T): T {
  if (Array.isArray(o)) {
    return o.map(deepClone) as any;
  } if (o && typeof o === 'object') {
    const result: any = {};
    Object.keys(o).forEach((key) => {
      result[key] = deepClone((o as any)[key]);
    });
    return result;
  }
  return o;
}
export function deepMutableClone<T>(o: T): DeepMutable<T> {
  return deepClone(o) as DeepMutable<T>;
}
